import { useMemo } from 'react'

import { BookingCategory, BookingQuestion, BookingType } from '@/api/booking-types'
import { useLocalStorage } from '@/hooks'

import { BOOKING_TYPES_SELECTION_STORAGE_KEY } from './booking-types.constants'
import {
  BookingSelection,
  EMPTY_SELECTION,
  parseStoredSelection,
  resolveSelection,
} from './booking-types.selection'

interface UseBookingTypesSelectionParams {
  groups: BookingCategory[]
  questions: BookingQuestion[]
  types: BookingType[]
}

export const useBookingTypesSelection = ({
  groups,
  questions,
  types,
}: UseBookingTypesSelectionParams) => {
  const [stored, setStored] = useLocalStorage<BookingSelection>(
    BOOKING_TYPES_SELECTION_STORAGE_KEY,
    EMPTY_SELECTION,
  )

  const selection = useMemo(
    () => resolveSelection({ groups, questions, stored: parseStoredSelection(stored), types }),
    [groups, questions, stored, types],
  )

  const selectGroup = (groupId: number) => setStored({ groupId, questionId: null, typeId: null })

  const selectType = (typeId: number) => setStored({ ...selection, questionId: null, typeId })

  const selectQuestion = (questionId: number) => setStored({ ...selection, questionId })

  return { selectGroup, selection, selectQuestion, selectType }
}
